import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import HomePage from "../pages/home/page";
import BizPage from "../pages/biz/page";
import PersonalPage from "../pages/personal/page";
import PlansPage from "../pages/plans/page";
import EventPage from "../pages/event/page";
import EnglishPage from "../pages/english/page";
import TermsPage from "../pages/terms/page";
import PrivacyPage from "../pages/privacy/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/english",
    element: <EnglishPage />,
  },
  {
    path: "/personal",
    element: <PersonalPage />,
  },
  {
    path: "/biz",
    element: <BizPage />,
  },
  {
    path: "/plans",
    element: <PlansPage />,
  },
  {
    path: "/event",
    element: <EventPage />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;